var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackAllowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "backAllowIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    transform: "translate(151 46)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "backAllowIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 285",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "BackArrowIcon",
    transform: "translate(-151 -46)",
    clipPath: "url(#backAllowIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "BackArrowIcon",
    transform: "translate(151 46)",
    clipPath: "url(#backAllowIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 312"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 328",
    d: "M24.422 4.02H.282A.281.281 0 000 4.3v5.228a.281.281 0 00.282.281h23.5a5.789 5.789 0 110 11.578H12.9v-3.91a.282.282 0 00-.428-.24L.69 24.347a.283.283 0 000 .483l11.778 7.11a.283.283 0 00.432-.24v-4.524h11.522a11.578 11.578 0 000-23.156",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackAllowIcon);
export default __webpack_public_path__ + "static/media/backAllowIcon.19e11b7ed5fc51c9.svg";
export { ForwardRef as ReactComponent };